/** DataTable props aligned with journals GenericListPage */
export const ACCOUNTING_TABLE_DEFAULTS = {
  density: 'normal' as const,
} as const;

/** DataTable header style */
export const acctTableHeader =
  'text-xs font-medium uppercase tracking-wider';

/** Filter / form field labels — matches GenericListPage FilterSection */
export const acctFieldLabel =
  'text-sm font-medium block mb-1.5';

/** Inline toolbar field labels */
export const acctToolbarLabel =
  'text-sm font-medium whitespace-nowrap';

/** Numeric cell alignment without monospace */
export const acctAmount = 'tabular-nums';
